<div class="login_form">


    <div class="logo">
        <img src="../../../../../assets/images/logo/flowtrics_logo.png">
    </div>
    <div class="title">FORGOT PASSWORD</div>
    <form name="forgotPassForm" [formGroup]="ForgotPassForm" novalidate autocomplete="off">

        <mat-form-field appearance="fill" class="mb-15">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" maxlength="50" placeholder="Enter email address">
            <mat-icon matSuffix class="secondary-text">mail</mat-icon>
            <mat-error *ngIf="ForgotPassForm.get('email').hasError('required')">
                Email is required
            </mat-error>
            <mat-error *ngIf="!ForgotPassForm.get('email').hasError('required') &&
                ForgotPassForm.get('email').hasError('email')">
                Please enter a valid email address
            </mat-error>
        </mat-form-field>


        <button mat-raised-button class="submit-button" 
        [disabled]="ForgotPassForm.invalid" (click)="forgotPassword(ForgotPassForm.value)" color="primary">Submit</button>

      <span class="back" [routerLink]="'/auth/login'"> <mat-icon>keyboard_arrow_left</mat-icon> Back to login</span>

    </form>
</div>
